import { useRef, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import * as echarts from "echarts";
import { useMantineTheme } from "@mantine/core";

const ConcentricCircleChart = ({ chartData1 }) => {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const chartRef1 = useRef(null);
  const [totalCount1, setTotalCount1] = useState(chartData1.length);

  useEffect(() => {
    setTotalCount1(chartData1.length);
  }, [chartData1]);

  const createDoughnutChart = (chartDom, chartData, totalCount) => {
    const projectStatuses = chartData
      .filter((project) => project?.projectStatus)
      .map((project) => project.projectStatus.toUpperCase());
    const uniqueStatuses = [...new Set(projectStatuses)];
    const statusCounts = uniqueStatuses.map(
      (status) => projectStatuses.filter((s) => s === status).length
    );
    const backgroundColors = {
      COMPLETED: "#53bb5d",
      INPROGRESS: "#1A79A9",
      SIMULATED: "#71CBE0",
    };

    const chart = echarts.init(chartDom);
    const option = {
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b}: {c} ({d}%)",
      },
      legend: {
        bottom: 0,
        left: "center",
        selectedMode: false,
        textStyle: {
          color: theme.colorScheme === "dark" ? "#d5d7e0" : "black",
          fontFamily: "Nunito",
          fontSize: 12,
          rich: {
            inactive: {
              color: theme.colorScheme === "dark" ? "#888" : "#bbb",
              textDecoration: "line-through",
              fontWeight: "normal",
            },
            active: {
              color: theme.colorScheme === "dark" ? "#d5d7e0" : "black",
              fontWeight: "normal",
            },
          },
        },
        data: uniqueStatuses,
      },
      series: [
        {
          name: "Projects",
          type: "pie",
          radius: ["50%", "70%"],
          center: ["50%", "40%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: "center",
            fontSize: 14,
            fontWeight: "normal",
            color: theme.colorScheme === "dark" ? "#d5d7e0" : "black",
            formatter: () => ` Projects: ${totalCount}`,
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 14,
              fontWeight: "normal",
            },
          },
          labelLine: {
            show: false,
          },
          data: uniqueStatuses.map((status, index) => ({
            value: statusCounts[index],
            name: status,
            itemStyle: {
              color: backgroundColors[status] || "#CCCCCC",
            },
          })),
        },
      ],
    };
    chart.setOption(option);

    return chart;
  };

  useEffect(() => {
    if (!chartRef1.current) return;
    const chart1 = createDoughnutChart(
      chartRef1.current,
      chartData1,
      totalCount1
    );
    return () => {
      chart1.dispose();
    };
    // eslint-disable-next-line
  }, [chartData1, totalCount1, theme.colorScheme]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
      data-testid="concentric-circle"
    >
      <div style={{ width: "250px", height: "250px", textAlign: "center" }}>
        <div
          data-intro={t('dashboard.pieChartProjectCount', { defaultValue: 'Pie chart to view Project count' })}
          data-position="left"
          ref={chartRef1}
          style={{ width: "100%", height: "100%", zoom: "115%" }}
        ></div>
      </div>
    </div>
  );
};

export default ConcentricCircleChart;
